import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "data-prep-custom-transformation" }
const _hoisted_2 = { class: "p-float-label p-field kn-flex" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = {
  key: 0,
  class: "p-float-label p-field p-mx-2"
}
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = {
  key: 1,
  class: "p-float-label p-field kn-flex"
}
const _hoisted_7 = { class: "kn-material-input-label" }
const _hoisted_8 = {
  key: 2,
  class: "p-float-label p-field kn-flex"
}
const _hoisted_9 = { class: "kn-material-input-label" }
const _hoisted_10 = {
  key: 3,
  class: "p-float-label p-field kn-flex"
}
const _hoisted_11 = { class: "kn-material-input-label" }
const _hoisted_12 = {
  key: 4,
  class: "p-float-label p-field kn-flex"
}
const _hoisted_13 = { class: "kn-material-input-label" }
const _hoisted_14 = {
  key: 5,
  class: "kn-flex"
}
const _hoisted_15 = { class: "p-float-label kn-material-input" }
const _hoisted_16 = { class: "kn-material-input-label" }
const _hoisted_17 = { id: "chips-help" }
const _hoisted_18 = { class: "p-d-flex p-jc-center p-ai-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Chips = _resolveComponent("Chips")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localTransformation, (filter, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "p-d-flex",
        key: index
      }, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_Dropdown, {
            modelValue: filter.column,
            "onUpdate:modelValue": ($event: any) => (filter.column = $event),
            options: _ctx.columns,
            class: "kn-material-input",
            optionLabel: "fieldAlias",
            filter: true,
            disabled: _ctx.col || _ctx.readOnly
          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.column')), 1)
        ]),
        (filter.column)
          ? (_openBlock(), _createBlock("span", _hoisted_4, [
              _createVNode(_component_Dropdown, {
                modelValue: filter.condition,
                "onUpdate:modelValue": ($event: any) => (filter.condition = $event),
                disabled: _ctx.readOnly,
                options: _ctx.getAvailableConditions(index),
                optionLabel: "label",
                optionValue: "code",
                class: "kn-material-input"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "options"]),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.conditions')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showStartDate(index))
          ? (_openBlock(), _createBlock("span", _hoisted_6, [
              _createVNode(_component_Calendar, {
                modelValue: filter.startDate,
                "onUpdate:modelValue": ($event: any) => (filter.startDate = $event),
                disabled: _ctx.readOnly,
                class: "kn-material-input"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.startDate')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showEndDate(index))
          ? (_openBlock(), _createBlock("span", _hoisted_8, [
              _createVNode(_component_Calendar, {
                modelValue: filter.endDate,
                "onUpdate:modelValue": ($event: any) => (filter.endDate = $event),
                disabled: _ctx.readOnly,
                class: "kn-material-input"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.endDate')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showInputText(index))
          ? (_openBlock(), _createBlock("span", _hoisted_10, [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filter.text,
                "onUpdate:modelValue": ($event: any) => (filter.text = $event),
                disabled: _ctx.readOnly,
                class: "kn-material-input"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.text')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showInputNumber(index))
          ? (_openBlock(), _createBlock("span", _hoisted_12, [
              _createVNode(_component_InputText, {
                type: "number",
                modelValue: filter.number,
                "onUpdate:modelValue": ($event: any) => (filter.number = $event),
                disabled: _ctx.readOnly,
                class: "kn-material-input"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.number')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showValuesList(index))
          ? (_openBlock(), _createBlock("span", _hoisted_14, [
              _createVNode("span", _hoisted_15, [
                _createVNode(_component_Chips, {
                  class: "kn-width-full",
                  multiple: true,
                  modelValue: filter.valuesList,
                  "onUpdate:modelValue": ($event: any) => (filter.valuesList = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.values')), 1)
              ]),
              _createVNode("small", _hoisted_17, _toDisplayString(_ctx.$t('common.chipsHint')), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("span", null, [
          (!_ctx.readOnly && _ctx.localTransformation.length > 1)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "pi pi-trash",
                class: 'p-button-text p-button-rounded p-button-plain',
                onClick: ($event: any) => (_ctx.deleteRow(index))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createVNode("span", _hoisted_18, [
      (!_ctx.readOnly)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "pi pi-plus",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewRow()))
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}